<template>
	<div class="custom-page">
		<ContainerObject
			v-if="campaignPaused"
			:containerObject="campaignPaused.layout"
		/>
		<div v-else class="paused-fallback">
			<div class="paused-fallback__panel">
				<h1 class="paused-fallback__title">Campaign paused</h1>
				<p class="paused-fallback__copy">
					This campaign is currently paused and is not accepting registrations or sign-ins right now.
				</p>
				<p class="paused-fallback__copy paused-fallback__copy--subtle">
					Please try again later.
				</p>
			</div>
		</div>
		<!-- <LoadingComponent v-if="loading" /> -->
	</div>
</template>

<script lang="ts">
import ContainerObject from "@/components/layout/ContainerObject.vue";
import { Action, CustomPage } from "@/types/customPage";
// import LoadingComponent from "@/components/utils/LoadingComponent.vue";
import { defineComponent } from "vue";
import { customPageStore } from "@/store/pinia_modules/customPageStore";
import { navigationStore } from "@/store/pinia_modules/navigationStore";
import { authStore } from "@/store/pinia_modules/authStore";
import { APIClient } from "@/utils/httpClient";

const POLL_INTERVAL_MS = 10_000;

export default defineComponent({
	// components: { ContainerObject, LoadingComponent },
	data() {
		return {
			loading: false,
			_pollTimer: null as ReturnType<typeof setInterval> | null,
			_pollInFlight: false,
		};
	},
	computed: {
		campaignPaused(): CustomPage | undefined {
			return customPageStore().getPageByURL("campaign-paused");
		},
		action(): Action {
			return navigationStore().getAction;
		},
	},
	mounted() {
		this._pollTimer = setInterval(this.checkPauseStatus, POLL_INTERVAL_MS);
	},
	beforeUnmount() {
		if (this._pollTimer !== null) {
			clearInterval(this._pollTimer);
			this._pollTimer = null;
		}
	},
	methods: {
		async checkPauseStatus(): Promise<void> {
			if (this._pollInFlight) return;
			const campaignId = authStore().getCampaignID;
			if (!campaignId) return;
			this._pollInFlight = true;
			try {
				const response = await APIClient.get(
					`/campaigns/${campaignId}/paused-status`
				);
				const data = response?.data?.data as { paused: boolean } | undefined;
				if (data && data.paused === false) {
					window.location.reload();
				}
			} catch (err) {
				console.warn("[CampaignPaused] pause-status poll failed:", err);
			} finally {
				this._pollInFlight = false;
			}
		},
	},
});
</script>

<style scoped lang="scss">
.custom-page {
	position: relative;
	width: 100%;
	height: 100%;
}

.paused-fallback {
	min-height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px 20px;
	background: linear-gradient(180deg, #0f172a 0%, #111827 100%);
	color: #f8fafc;
}

.paused-fallback__panel {
	width: min(100%, 520px);
	padding: 28px 24px;
	border-radius: 20px;
	background: rgba(15, 23, 42, 0.88);
	border: 1px solid rgba(148, 163, 184, 0.24);
	box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
	text-align: center;
}

.paused-fallback__title {
	margin: 0 0 12px;
	font-size: 2rem;
	line-height: 1.1;
}

.paused-fallback__copy {
	margin: 0;
	font-size: 1rem;
	line-height: 1.6;
}

.paused-fallback__copy--subtle {
	margin-top: 10px;
	color: rgba(226, 232, 240, 0.78);
}
</style>
